export enum ProblemType {
  WRONG_DATA = "WRONG_DATA",
  CLAIM = "CLAIM",
  REQUEST = "REQUEST",
  OTHER = "OTHER",
}
